<template>
<div>
    <SimplePopup 
        :title="popupTitle"
        :message="popupMessage"
        :buttonText="'button > continue'"
        v-on:dismiss="popupTitle=null;popupMessage=null;$controller.view.editProfile.open();"
    />
</div>  
</template>

<script>
import SimplePopup from '@/components/UI/SimplePopup.vue';

export default {
    components: {
        SimplePopup
    },
    data: function(){
        return {
            migrationTimestamp: '2020-09-29 01:02:03',
            popupMessage: null,
            popupTitle: null            
        }
    },
    computed: {
        evalPopup: function(){
            return this.firstMigratedUserLogin();
        }
    },
    watch: {
        evalPopup: function(after, before){
            if(after===true){
                this.popupMessage = "welcome wizard > message";
                this.popupTitle = "welcome wizard > title";
            }
        }
    }
}
</script>

<style>

</style>